import React from 'react';
import Tooltip from '../common/Tooltip';

const TagButton = ({ tags, onClick }) => {
  if (!tags || tags.length === 0) {
    return (
      <button
        type="button"
        onClick={onClick}
        className="inline-flex items-center cursor-pointer text-sm bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 px-3 py-1 rounded-md text-gray-600 dark:text-gray-300"
      >
        Set tags
      </button>
    );
  }

  const fullText = tags.map(t => t.name).join(', ');

  return (
    <Tooltip title={fullText} position="bottom" trigger="mouseenter" interactive={false} arrow={true} theme="dark" size="small">
      <button
        type="button"
        onClick={onClick}
        className="flex flex-wrap items-center gap-1 text-left cursor-pointer rounded-md bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 px-2 py-1"
      >
        <span className="text-sm text-gray-500 dark:text-gray-400 mr-1">Tags:</span>
        {tags.map(tag => (
          <span
            key={tag.id || tag.name}
            className="inline-flex max-w-full items-center rounded-full bg-gray-200 dark:bg-gray-600 px-2 py-0.5 text-xs text-gray-700 dark:text-gray-200"
          >
            {tag.name}
          </span>
        ))}
      </button>
    </Tooltip>
  );
};

export default TagButton;
